[
  "@babel/plugin-proposal-export-default-from",
  "@babel/plugin-syntax-export-default-from",
  "@babel/plugin-transform-private-methods",
  "@babel/plugin-transform-private-property-in-object",
  "@babel/plugin-transform-runtime",
  "@bufgix/react-native-secure-window",
  "@expo/metro-runtime",
  "@expo/vector-icons",
  "@miblanchard/react-native-slider",
  "@react-native-async-storage/async-storage",
  "@react-native-community/masked-view",
  "@react-native-community/slider",
  "@react-navigation/drawer",
  "@react-navigation/native",
  "@react-navigation/stack",
  "@sentry/react-native",
  "@types/node",
  "@types/react",
  "axios",
  "bcryptjs",
  "bowser",
  "chart.js",
  "cypress-iframe",
  "diff",
  "easy-peasy",
  "eslint-config-expo",
  "expo",
  "expo-auth-session",
  "expo-av",
  "expo-blur",
  "expo-build-properties",
  "expo-clipboard",
  "expo-constants",
  "expo-crypto",
  "expo-dev-client",
  "expo-device",
  "expo-file-system",
  "expo-font",
  "expo-linking",
  "expo-navigation-bar",
  "expo-network",
  "expo-screen-capture",
  "expo-screen-orientation",
  "expo-secure-store",
  "expo-sharing",
  "expo-splash-screen",
  "expo-status-bar",
  "expo-video",
  "expo-web-browser",
  "highcharts",
  "highcharts-react-official",
  "html2canvas",
  "localforage",
  "lodash",
  "moment",
  "nativewind",
  "p-limit",
  "posthog-react-native",
  "prettier",
  "prop-types",
  "react",
  "react-dom",
  "react-error-boundary",
  "react-hook-form",
  "react-markdown",
  "react-native",
  "react-native-aes-gcm-crypto",
  "react-native-animatable",
  "react-native-confetti-cannon",
  "react-native-default-preference",
  "react-native-device-info",
  "react-native-element-dropdown",
  "react-native-elements",
  "react-native-gesture-handler",
  "react-native-get-random-values",
  "react-native-keyboard-aware-scroll-view",
  "react-native-modal",
  "react-native-progress",
  "react-native-reanimated",
  "react-native-render-html",
  "react-native-safe-area-context",
  "react-native-screens",
  "react-native-slider",
  "react-native-slider-web",
  "react-native-ssl-public-key-pinning",
  "react-native-svg",
  "react-native-toast-message",
  "react-native-uuid",
  "react-native-vector-icons",
  "react-native-web",
  "react-native-webview",
  "typescript"
]
